import React, { useState } from 'react';
import Panel from '../Panel';
import styles from './PaymentPanel.module.scss';
import { PaymentCadence } from './CadenceToggle';
import { AccountType } from '../SelectAccountTypePanel';
import BaseObject from '@repo/utils/models/BaseObject';
import PaymentForm from './PaymentForm';
import ProductPlanCopy from './ProductPlanCopy';
import { IAPProduct } from '@repo/utils/types';
import IAPOptions from './IAPOptions';

interface ProductPlan {
  id: `${AccountType}_-${PaymentCadence}`;
  price: number;
  currency: string;
}

export class ClayProduct extends BaseObject {
  name: AccountType;
  trialDaysLeft: number;
  plans: {
    year: ProductPlan;
    month: ProductPlan;
  };

  constructor(props) {
    super(props);
    this.name = props.product;
    this.trialDaysLeft = props.trial_days;
    this.plans = props.plans;
  }
}

const cadenceToKey = {
  monthly: 'month',
  annually: 'year',
};

export interface SetupIntent {
  client_secret: string;
  intent_id: string;
}

export default function PaymentPanel({
  product,
  setupIntent,
  iAPProducts,
  onProductPurchased,
}: {
  product: ClayProduct;
  setupIntent: SetupIntent;
  iAPProducts: IAPProduct[];
  onProductPurchased: () => void;
}) {
  const [paymentCadence, setPaymentCadence] = useState<PaymentCadence>('monthly');
  const cadence = cadenceToKey[paymentCadence] as 'month' | 'year';
  const productPlan: ProductPlan = product.plans[cadence];

  return window.desktopIntegrations?.appInfo.isMAS ? (
    <Panel className={styles.panelWithTOS}>
      <ProductPlanCopy product={product} cadence={cadence} />
      <IAPOptions
        iAPProducts={iAPProducts}
        onProductPurchased={onProductPurchased}
        setPaymentCadence={setPaymentCadence}
      />
      <div className={styles.tos}>
        By continuing you agree to Clay's{' '}
        <a href="https://clay.earth/terms" target="_blank">
          Terms of Service
        </a>{' '}
        and{' '}
        <a href="https://clay.earth/privacy" target="_blank">
          Privacy Policy
        </a>
      </div>
    </Panel>
  ) : (
    <Panel>
      <ProductPlanCopy product={product} cadence={cadence} />
      <PaymentForm
        cadence={paymentCadence}
        setCadence={setPaymentCadence}
        setupIntent={setupIntent}
        planID={productPlan.id}
        trialDaysLeft={product.trialDaysLeft}
        accountType={product.name}
      />
    </Panel>
  );
}
